import { MenuItem } from '../types/menu'

/** Items Claude read with confidence below this are flagged for review */
export const REVIEW_CONFIDENCE_THRESHOLD = 0.7

export function needsReview(item: MenuItem): boolean {
  return typeof item.confidence === 'number' && item.confidence < REVIEW_CONFIDENCE_THRESHOLD
}
